import * as React from 'react';
import './FileDropZone.css';

export interface IFileDropZoneProps {
  accept: string;
  multiple: boolean;
  disabled: boolean;
  mainLabel: string;
  subLabel: string;
  onFilesSelected: (files: File[]) => void;
}

function fileListToArray(fileList: FileList | null | undefined): File[] {
  if (fileList === null || fileList === undefined) {
    return [];
  }
  return Array.from(fileList);
}

function getFileDropZoneClassName(disabled: boolean): string {
  if (disabled) {
    return 'FileDropZone FileDropZone-disabled';
  }
  return 'FileDropZone';
}

export const FileDropZone: React.FC<IFileDropZoneProps> = function (props) {
  const handleDragOver = (event: React.DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (props.disabled) {
      event.dataTransfer.dropEffect = 'none';
    } else {
      event.dataTransfer.dropEffect = 'copy';
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const files = fileListToArray(event.dataTransfer.files);
    if (!props.disabled && files.length > 0) {
      props.onFilesSelected(files);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.currentTarget;
    const files = fileListToArray(event.target.files);
    if (!props.disabled && files.length > 0) {
      props.onFilesSelected(files);
    }
    input.value = '';
  };

  const labelClassName = getFileDropZoneClassName(props.disabled);

  return (
    <label className={labelClassName} onDragOver={handleDragOver} onDrop={handleDrop}>
      <input
        type="file"
        accept={props.accept}
        multiple={props.multiple}
        disabled={props.disabled}
        className="FileDropZone-input"
        onChange={handleChange}
      />
      <div className="FileDropZone-label_container">
        <div className="FileDropZone-label FileDropZone-main_label">{props.mainLabel}</div>
        <div className="FileDropZone-label FileDropZone-sub_label">{props.subLabel}</div>
      </div>
    </label>
  );
};
